<template>
  <div>
    <van-nav-bar
      title="订单"
      left-text="返回"

      left-arrow
      @click-left="onClickLeft"
    />



    <div>
      <h4>订单信息</h4>
      <table align="center" border="1" cellpadding="10px" cellspacing="0" style="margin-top:20px;font-size: 12px;width: 100%;">
        <tr>
          <td>销售</td>
          <td>{{ordersinfo.salername}}</td>
          <td>客户</td>
          <td>{{ordersinfo.clientname}}</td>
        </tr>

        <tr>

          <td>联系人</td>
          <td>{{ordersinfo.lxr}}</td>
          <td>电话</td>
          <td>{{ordersinfo.phone}}</td>
        </tr>
        <tr>

          <td>配送方式</td>
          <td>{{ordersinfo.send_type}}</td>
          <td>付款方式</td>
          <td>{{ordersinfo.pay_type}}</td>
        </tr>
        <tr>
          <td>地址</td>
          <td colspan="3">{{ordersinfo.address}}</td>
        </tr>
        <tr>
          <td>订单状态</td>
          <td>{{ordersinfo.dis_status}}</td>
          <td>订单金额</td>
          <td>{{ordersinfo.total_price}}</td>
        </tr>
        <tr>
          <td>备注</td>
          <td colspan="3">{{ordersinfo.beizhu}}</td>
        </tr>
        <tr>
          <td colspan="2">
            <van-button  block type="warning" @click="tuihuiorder" v-if="ordersinfo.status!=0" size="small">退回</van-button>


          </td>
          <td colspan="2"><van-button  block type="info" @click="show=false" v-if="ordersinfo.status==1" size="small">调货完成</van-button></td>
        </tr>
      </table>


      <h4>订单产品</h4>
        <table align="center" border="1" cellpadding="10px" cellspacing="0" style="font-size: 12px;width:100%;" >
              <thead>
                  <tr>
                      <th>产品名称</th>
                      <th>数量</th>
                      <th>已调货</th>
                      <th>单位</th>
                      <th>单价</th>
                      <th>小计</th>
                      <th>操作</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="item in ordersinfo.products">
                      <td>{{item.name}}</td>
                      <td>{{item.count}}</td>
                      <td>{{item.dhcount}}</td>
                      <td>{{item.danwei}}</td>
                      <td>{{Number(item.price_line)}}</td>
                      <td>{{item.xiaoji}}</td>
                      <td><a @click="dh(item)" style="color:chocolate;">调货</a></td>
                  </tr>
             </tbody>
         </table>
        <van-row style="margin-top: 20px;">
          <van-col span="10"><h4>配送单</h4></van-col>
          <van-col span="2" :offset="12"><van-button icon="plus" type="primary" size="mini" style="margin-top: 20px;" @click="createsendorder"/></van-col>
        </van-row>
        <table v-for="item in sendorders" align="center" border="1" cellpadding="10px" cellspacing="0" style="font-size: 12px;margin-top: 20px;;width: 100%;">
          <tr>
            <td colspan="3" >配送单：{{item.sendbh}}</td>
            <td v-if="item.status==0" style="width:50px">未发布</td>
            <td v-if="item.status==1" style="width:50px">等待配送</td>
            <td v-if="item.status==2" style="width:50px">配送完成</td>
            <td>
              <a v-if="item.status==0" @click="delpeisong(item.id)" style="color:chocolate;">删除</a>
            </td>
            <td>
              <a v-if="item.status==0" @click="fabupeisong(item.id)" style="color:chocolate;">发布</a>
              <a v-if="item.status!=0" @click="chehuipeisong(item.id)" style="color:chocolate;">撤回</a>
              </td>




          </tr>
          <tr>
            <td>产品</td>
            <td>仓库</td>
            <td>单价</td>
            <td>数量</td>
            <td>小计</td>
            <td>操作</td>
          </tr>
          <tr v-for="pd in item.chukulogs">
            <td style="width:110px">{{pd.productname}}</td>
            <td style="width:38px">{{pd.cangkuname}}</td>
            <td>{{Number(pd.unit_price)}}</td>
            <td>{{pd.count}}</td>
            <td>{{Number(pd.total_price)}}</td>
            <td @click="removediaohuo(pd)" style="color:chocolate;">移除</td>
          </tr>
        </table>







    </div>
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper" @click.stop >
          <div style="width: 100%;height: 650px;background-color: #FFF;font-size: 12px;">
            <van-cell-group>

                <van-field label="产品" :value="dhform.name" readonly />
                <van-field v-model="dhform.count" type="digit" label="数量" readonly/>
                <van-field v-model="dhform.dhcount" type="digit" label="调货数量" />
                <van-field name="radio" label="调货批次"></van-field>

                      <van-radio-group v-model="dhform.dhid">
                        <van-radio style="margin-top: 10px;margin-left:15px;" shape="square" :name="inventitem.id" v-for="inventitem in dhform.dhpc" :key="inventitem.id">{{inventitem.cangkuname}} - 厂商：{{inventitem.factoryname}} - 剩余{{inventitem.remaining_count}} - 成本{{inventitem.cost_unit}}</van-radio>
                      </van-radio-group>

                <van-field name="radio" label="配送单"></van-field>
                <van-radio-group v-model="dhform.sendorder">
                  <van-radio style="margin-top: 10px;margin-left:15px;" shape="square" :name="sditem.id" v-for="sditem in sendorders" :key="sditem.sendbh">配送单：{{sditem.sendbh}}</van-radio>

                </van-radio-group>


            </van-cell-group>

             <div style="margin-top: 30px;">
               <van-row>
                 <van-col :span="6"><van-button  block type="warning" @click="show=false">取消</van-button></van-col>

                 <van-col :span="18"><van-button  block type="info" @click="diaohuo">提交</van-button></van-col>
                 </van-row>


              </div>
          </div>
        </div>
      </van-overlay>

  </div>
</template>

<script>
  import * as Api from './api.js'
import { Toast } from 'vant';
import { Notify } from 'vant';

  export default {
    name: 'RukuList',
    data () {
      return {
        value:'',
        ordersinfo:{
          products:[]
        },
        orderid:'',
        sendorders:[],
        show:false,
        dhform:{},
        inventorys:[]


      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo')
      console.log(this.$route.query.id)
      this.orderid = this.$route.query.id
      this.getorderdetail()
      this.getpsorder()
    },
    methods:{
      getorderdetail(){
        Api.Orderdetail(this.orderid).then(res=>{
          this.ordersinfo = res.data
        })

      },
      onClickLeft(){
        this.$router.push({path:'/shangwuviews/orders'})
      },
      dh(row){
        console.log(row)
        this.dhpd = row
        let query = {
           product:row.id,
           remaining_count__gt:0,
           limit:999
         }
        Api.GetInventoryList(query).then(res=>{
          this.dhform = {
            name:row.name,
            count:row.count,
            nocount:row.count - row.dhcount,
            dhcount:0,
            dhpc:res.data.data.reverse(),
            dhid:'',
            uuid:row.uuid,
            sendorder:''

          }

        this.show = true
        })
      },
      getpsorder(){
        var that =this
        let query={
          order:this.orderid,
          limit:999
        }
        Api.getpsorder(query).then(res=>{
          that.sendorders =res.data
        })
      },
      createsendorder(){
        let obj = {
          order:this.orderid
        }
        Api.createsendorder(obj).then(res=>{
         Notify({ type: 'success', message: res.msg });

           this.getpsorder()
        })
      },
      removediaohuo(item){
        Api.RemoveDiaohuo({id:item.id}).then(res=>{
          Notify({ type: 'success', message: res.msg });
          this.getorderdetail()
          this.getpsorder()
        })
      },
      diaohuo(){
        let obj = {
          dhid:this.dhform.dhid,
          dhcount:Number(this.dhform.dhcount),
          orderid:Number(this.orderid),
          uuid:this.dhform.uuid,
          sendorder:this.dhform.sendorder


        }
        console.log(obj)
        Api.Diaohuo(obj).then(res=>{
          this.show = false
          Notify({
                   message: '调货完成！',
                   type: 'success'
                 });
          this.getorderdetail()
          this.getpsorder()
        })
      },
      tuihuiorder(){
        this.sendorders.forEach(item=>{
          if(item.chukulogs.length>0){
            Notify({
                     message: '请移除调货记录后再次退回！',
                     type: 'warning'
                   });
            return false
          }
        })


        let query={
          id:this.orderid
        }
        Api.Tuihuiorder(query).then(res=>{
          Notify({
                   message: res.msg,
                   type: 'success'
                 });

          this.getorderdetail()

        })
      },
      fabupeisong(sendorder){
        let obj = {
          sendorder:sendorder
        }
        Api.fabusendorder(obj).then(res=>{
          Notify({
                   message: res.msg,
                   type: 'success'
                 });
          this.getpsorder()
        })
      },
      chehuipeisong(sendorder){
        let obj = {
          sendorder:sendorder
        }
        Api.chehuisendorder(obj).then(res=>{
          Notify({
                   message: res.msg,
                   type: 'success'
                 });
          this.getpsorder()
        })
      },
      delpeisong(id){

        Api.Delpeisong(id).then(res=>{
          Notify({
                   message: res.msg,
                   type: 'success'
                 });
          this.getpsorder()
        })
      }

    }
  }

</script>

<style>
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/shangwuviews/orderdetail/index.vue